import Icon from "../../../components/AppIcon";

interface ProjectStatsProps {
  totalProjects: number;
  completedProjects: number;
  inProgressProjects: number;
  totalCommits: string;
  totalLinesOfCode: string;
}

const ProjectStats = ({
  totalProjects,
  completedProjects,
  inProgressProjects,
  totalCommits,
  totalLinesOfCode,
}: ProjectStatsProps) => {
  const stats = [
    {
      icon: "FolderGit2",
      label: "Total Projects",
      value: totalProjects,
      color: "primary",
    },
    {
      icon: "CheckCircle2",
      label: "Completed",
      value: completedProjects,
      color: "success",
    },
    {
      icon: "Clock",
      label: "In Progress",
      value: inProgressProjects,
      color: "warning",
    },
    {
      icon: "GitCommit",
      label: "Total Commits",
      value: '25k+',
      color: "secondary",
    },
    {
      icon: "Code2",
      label: "Lines of Code",
      value: '50k+',
      color: "accent",
    },
  ];

  const getColorClasses = (color: string) => {
    switch (color) {
      case "primary":
        return "bg-primary/10 text-primary";
      case "success":
        return "bg-success/10 text-success";
      case "warning":
        return "bg-warning/10 text-warning";
      case "secondary":
        return "bg-secondary/10 text-secondary";
      case "accent":
        return "bg-accent/10 text-accent";
      default:
        return "bg-muted text-muted-foreground";
    }
  };

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-8">
      {stats.map((stat, index) => (
        <div
          key={index}
          className="bg-card rounded-lg border border-border p-6 hover:shadow-elevation-2 transition-all duration-300"
        >
          <div className={`w-12 h-12 rounded-lg ${getColorClasses(stat.color)} flex items-center justify-center mb-4`}>
            <Icon name={stat.icon} size={24} />
          </div>
          <p className="text-2xl font-bold text-foreground mb-1">{stat.value}</p>
          <p className="text-sm text-muted-foreground">{stat.label}</p>
        </div>
      ))}
    </div>
  );
};

export default ProjectStats;